var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { ConsentDateSearchInput, ConsentType, IdentifiedPatientState } from "./consent.dtos";
import { StudyWithIncludesDto } from "./study-with-includes.dtos";
import { BaseStudySearchInput } from "./study.dtos";
import { USAStates } from "./usaStates";
export class StudyPatientConsentTotalsResult {
}
__decorate([
    IsNumber()
], StudyPatientConsentTotalsResult.prototype, "all", void 0);
__decorate([
    IsNumber()
], StudyPatientConsentTotalsResult.prototype, "pending", void 0);
__decorate([
    IsNumber()
], StudyPatientConsentTotalsResult.prototype, "optedIn", void 0);
__decorate([
    IsNumber()
], StudyPatientConsentTotalsResult.prototype, "optedOut", void 0);
export class StudyPatientConsentSearchInput {
}
__decorate([
    ValidateNested(),
    Type(() => BaseStudySearchInput),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "study", void 0);
__decorate([
    IsString(),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(ConsentType, { each: true }),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "consentType", void 0);
__decorate([
    IsString(),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "patientId", void 0);
__decorate([
    IsEnum(USAStates),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "patientState", void 0);
__decorate([
    ValidateNested(),
    Type(() => ConsentDateSearchInput),
    IsOptional()
], StudyPatientConsentSearchInput.prototype, "timestamp", void 0);
export class StudyPatientConsentSearchResult {
}
__decorate([
    IsNumber()
], StudyPatientConsentSearchResult.prototype, "total", void 0);
__decorate([
    Type(() => PatientConsentsByStudyDto),
    ValidateNested({ each: true })
], StudyPatientConsentSearchResult.prototype, "results", void 0);
export class PatientConsentsByStudyDto {
}
__decorate([
    Type(() => StudyWithIncludesDto),
    ValidateNested()
], PatientConsentsByStudyDto.prototype, "study", void 0);
__decorate([
    Type(() => PatientConsentDto),
    ValidateNested({ each: true })
], PatientConsentsByStudyDto.prototype, "consents", void 0);
export class PatientConsentDto {
}
__decorate([
    IsString()
], PatientConsentDto.prototype, "id", void 0);
__decorate([
    IsString()
], PatientConsentDto.prototype, "patientId", void 0);
__decorate([
    IsEnum(ConsentType)
], PatientConsentDto.prototype, "consentType", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], PatientConsentDto.prototype, "timestamp", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientConsentDto.prototype, "consentingByLink", void 0);
__decorate([
    IsEnum(IdentifiedPatientState),
    IsOptional()
], PatientConsentDto.prototype, "state", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientConsentDto.prototype, "pending", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientConsentDto.prototype, "updateRecordsNeeded", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientConsentDto.prototype, "recordsRetrievalNeeded", void 0);
